import {Component} from "react";
import {Modal} from "react-bootstrap";
import {Button} from "@mantine/core";
import '../../../../../css/components/CustomModal.css';

/**
 * @author KMU
 * Helper class to define a custom modal
 */

type Props = {
    title: string,
    body: string,
    showModal: boolean,
    decline: boolean,
    handleOk: () => void,
    handleCancel: () => void,
    okText?: string,
    cancelText?: string
};
type State = {};
export default class CustomModal extends Component<Props, State>{

    constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false
        };
    }

    render(){
        const {okText = "Ok", cancelText = "Abbrechen"} = this.props
        return(
            <Modal show={this.props.showModal} onHide={this.props.handleCancel}
                   id="customModal" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{this.props.body}</Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.handleOk}>
                        {okText}
                    </Button>
                    {this.props.decline ?
                        <Button onClick={this.props.handleCancel}>
                            {cancelText}
                        </Button> : <></>
                    }
                </Modal.Footer>
            </Modal>
        )
    }
}